// extracted by mini-css-extract-plugin
export default {"form-container":"EmailCodeConfirmation_form-container__R5B52","image-container":"EmailCodeConfirmation_image-container__L6PfY"};